import React, { Fragment } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Avatar from '@atlaskit/avatar';

import PageIcon24 from '@atlaskit/icon-object/glyph/page/24';
import BlogIcon24 from '@atlaskit/icon-object/glyph/blog/24';
import Issue24Icon from '@atlaskit/icon-object/glyph/issue/24';
import Whiteboard24Icon from './icons/Whiteboard24Icon';

import { AttachmentIcon } from '@atlassian/search-common';

type ContentIconRendererArgs = {
	type: string;
	title?: string | null | undefined;
	iconCssClass?: string;
	size?: 'medium' | 'small';
	imageSrc?: string;
};

type GenericIconRendererArgs = {
	iconUrl: string;
	size?: 'small' | 'xsmall';
	appearance?: 'square' | 'circle';
};

const negativeMarginStyles = xcss({
	margin: 'space.negative.025',
	display: 'flex',
});

export const ContentIconRenderer = ({
	type,
	size = 'medium',
	imageSrc,
	title,
}: ContentIconRendererArgs) => {
	if (type === 'page' || type === 'confluence-page' || type === 'content') {
		return <PageIcon24 label={type} />;
	} else if (type === 'blogpost' || type === 'confluence-blogpost') {
		return <BlogIcon24 label={type} />;
	} else if (type === 'whiteboard') {
		// TODO: swap out when AK supports the whiteboard icon
		return <Whiteboard24Icon size={size} label={type} />;
	} else if (type === 'attachment') {
		return <AttachmentIcon title={title || ''} size="medium" label={type} />;
	} else if (type === 'jira') {
		return <Issue24Icon label={type} />;
	} else if (type === 'atlas') {
		return <img width="24px" height="24px" src={imageSrc || ''} aria-label={type} alt={type} />;
	}
	return <Fragment />;
};

export const GenericIconRenderer = ({
	iconUrl,
	size = 'small',
	appearance = 'square',
}: GenericIconRendererArgs) => (
	<Box xcss={negativeMarginStyles}>
		<Avatar
			size={size}
			borderColor="transparent"
			src={iconUrl}
			appearance={appearance}
			testId="result-avatar"
		/>
	</Box>
);
